import service from '@/utils/server';

const modName='/md/reshipSku/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};


//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//导入方法
export const routeUpLoad = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'reshipSkuUpLoad',
    method: 'post',
    data
  });
};

//模板下载
export const template = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/reshipSku/api/index.js